import Input from "../../UI/Input";
import { FieldErrors, UseFormWatch } from "react-hook-form";
import { useState } from "react";

export declare type LabledInputClasses = {
    wrapper: string;
    field: string;
    label: string;
}
interface Props {
    label: string;
    inputName: string;
    watch: UseFormWatch<any>;
    classes?: Partial<LabledInputClasses>;
    errors: FieldErrors;
}

export default function LabeledInput({
    label,
    inputName,
    watch,
    classes,
    errors,
    ...inputProps
}: Props) {
    const hasError = !!errors[inputName];

    const [isFocused, setIsFocused] = useState(false);

    const value = watch(inputName);
    const isActive = isFocused || !!value

    return (
        <div className={`labeled-input__wrapper ${isActive ? 'active' : ''} ${classes ? classes.wrapper : ''}`}>
            <Input
                type="text"
                grayStyle
                placeholder=''
                className={`labeled-input__input ${hasError ? "invalid" : ''} ${classes ? classes.field : ''}`}
                
                {...inputProps}

                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
            <label className={`labeled-input__label ${classes ? classes.label : ''}`}>
                {label}
            </label>
        </div>
    );
}
